import axios, { AxiosResponse } from "axios";
import { components, paths } from "../types/OnuoGate";

export function ApiClient(baseUrl: string) {
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 15000 * 20,
  });
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        (error.status === 401 || error.status === 403) &&
        error.request.responseURL.toString().indexOf("auth") == -1
      ) {
        window.location.href = "/login";
      }
      return Promise.reject(error);
    },
  );

  const requests = {
    setToken: (newToken: string) => {
      instance.defaults.headers["Authorization"] = "Bearer " + newToken;
    },

    sync: () => {
      return instance.get("/sync");
    },
    getOrders: (
      params: paths["/planogram/orders"]["get"]["parameters"]["query"],
    ): Promise<
      AxiosResponse<components["schemas"]["OpenOrderIPaginationResult"]>
    > => {
      return instance.get("planogram/orders", {
        params,
      });
    },
    getOrderLines: (
      params: paths["/planogram/order/orderLines"]["get"]["parameters"]["query"],
      isExport: boolean = false,
    ): Promise<
      AxiosResponse<components["schemas"]["OpenOrderLineIPaginationResult"]>
    > => {
      return instance.get("planogram/order/orderLines", {
        params,
        responseType: isExport ? 'blob': 'json'
      });
    },
    getOrderDetail: (
      params: paths["/planogram/order/{id}"]["get"]["parameters"]["path"],
    ): Promise<AxiosResponse<components["schemas"]["OpenOrder"]>> => {
      return instance.get("planogram/order/" + params.id);
    },
    addSaleKit: (
      params: paths["/planogram/order/{id}"]["post"]["parameters"]["path"],
      data: components["schemas"]["SaleKitRequest"],
    ) => {
      console.log(data);
      return instance.post("planogram/order/" + params.id, data);
    },
    searchLogoDevice: (
      params: paths["/planogram/logo/search"]["get"]["parameters"]["query"],
    ): Promise<AxiosResponse<components["schemas"]["LogoDevice"][]>> => {
      return instance.get("planogram/logo/search", {
        params,
      });
    },

    searchPayPlans: (
        params: paths["/planogram/logo/payplans/search"]["get"]["parameters"]["query"],
    ): Promise<AxiosResponse<components["schemas"]["LogoPayPlan"][]>> => {
      return instance.get("planogram/logo/payplans/search", {
        params,
      });
    },

    searchLogoAddress: (
        params: paths["/planogram/logo/shipAddress/search"]["get"]["parameters"]["query"],
    ): Promise<AxiosResponse<components["schemas"]["LogoShipInfo"][]>> => {
      return instance.get("planogram/logo/shipAddress/search", {
        params,
      });
    },

    updateDeliveryAddress: (
        data: components["schemas"]["UpdateDeliveryAddressRequest"],
    ): Promise<AxiosResponse> => {
      return instance.post("planogram/update/deliveryAddress",data);
    },


    changeLogoHandset: (
      params: paths["/planogram/order/{id}/changeDeviceCode"]["post"]["parameters"]["path"],
      data: components["schemas"]["ChangeOrderHandCodeRequest"],
    ): Promise<AxiosResponse<components["schemas"]["LogoDevice"][]>> => {
      return instance.post(
        `/planogram/order/${params.id}/changeDeviceCode`,
        data,
      );
    },

    loginRequest: (
      data: components["schemas"]["LoginRequest"],
    ): Promise<AxiosResponse<components["schemas"]["TokenResponse"]>> => {
      return instance.post("/auth", data);
    },
    editOrder: (data: components["schemas"]["OrderEditRequest"]) => {
      return instance.put("/planogram/order/edit", data);
    },
    deleteOrderLine: (orderLineId: number) => {
      return instance.delete("planogram/order/line", {
        params: {
          orderLineId,
        },
      });
    },
    createLogoOrder: (orderItemIds: number[]) => {
      return instance.post("planogram/order/createLogoOrder", orderItemIds);
    },
    completeVodafoneOrder: (orderId: number) => {
      return instance.post(
        "planogram/order/completeVodafoneOrder",
        {},
        {
          params: {
            orderId,
          },
        },
      );
    },
    bulkOpenOrderLineHandsetUpdate: (data: components["schemas"]["BulkHandsetChange"]) => {
      return instance.post(
          "planogram/order/orderLines/bulk/changeDeviceCode",data
      );
    } ,

    bulkOpenOrderLinePayPlanUpdate: (data: components["schemas"]["BulkPayPlanRequest"]) => {
      return instance.post(
          "planogram/order/orderLines/bulk/changePayPlan",data
      );
    } ,
    
    
    bulkOpenOrderLineApprove: (data: components["schemas"]["BulkApproveRequest"]) => {
      return instance.post(
          "planogram/order/orderLines/bulk/send2",data
      );
    },
    bulkOpenOrderLineStatusUpdate: (data: components["schemas"]["BulkStatusChange"]) => {
      return instance.post(
          "planogram/order/openOrderLine/bulk/status",data
      );
    },
    getConfigs: (
    ): Promise<
        AxiosResponse<components["schemas"]["LogoDefaultConfig"][]>
    > => {
      return instance.get("config", {
      });
    },
  };
  const token = localStorage.getItem("token");

  if (token) {
    requests.setToken(token);
  }

  return requests;
}

// @ts-ignore
export default ApiClient(process.env.REACT_APP_PUBLIC_URL || "http://localhost:5109/");
